import { render, staticRenderFns } from "./getNotify.vue?vue&type=template&id=796ff6a0"
import script from "./getNotify.vue?vue&type=script&lang=js"
export * from "./getNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports